import * as React from "react"
const SixteenOZIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      d="M8.7 5.5h7.85a.5.5 0 0 1 .496.43l.004.105-.858 12a.5.5 0 0 1-.498.465H9.556a.5.5 0 0 1-.483-.37l-.015-.095-.858-12a.5.5 0 0 1 .5-.535Z"
    />
  </svg>
)
export default SixteenOZIcon;
